import { $el, noscroll, appShadowRoot } from '../../common/elements';
import { o } from '../../common/observable';
import { render } from '../../common/page';
import { views } from '../../common/views';
import { decorated } from './decorated';
import { rewrite } from './rewrite';

export function close() {
  render(() => {
    $el.modal.classList.remove('is-active');
    $el.modalContent.innerHTML = '';

    if (($el.modal.dataset?.type ?? '').length > 0) {
      $el.modal.classList.remove($el.modal.dataset.type);
      $el.modal.dataset.type = '';
    }

    noscroll($el.html, false);
    o.dispatch('close');
  });
}

export function modal(view, args = null, type = '', passthru = false) {
  if (decorated.get('modal') !== true) {
    decorated.set('modal', true);
    appShadowRoot.querySelector('.modal-close').addEventListener('click', close, false);
    appShadowRoot.querySelector('.modal-background').addEventListener('click', close, false);
    document.addEventListener('keydown', (ev) => (ev.key === 'Escape' ? close() : void 0), false);
  }

  const html =
    passthru || /^preferences|awards|case-(action|watcher)$/.test(type)
      ? views.get(view)(args)
      : views.get(view)(args !== null ? rewrite(args) : void 0);

  render(() => {
    $el.modalContent.innerHTML = html;
    $el.modal.classList.add('is-active');
    $el.modal.dataset.type = type;
    noscroll($el.html, true);
  });
}
